import { z } from "zod";
import { UserSchema } from "./User";

export const UpdateUserPasswordRequestSchema = UserSchema.pick({
    password: true,
})

export type UpdateUserPasswordRequest = z.infer<typeof UpdateUserPasswordRequestSchema>;